import { LanguageResponse } from "@/generated-api";
import BadgeWithFlag from "./BadgeWithFlag";
import { useTranslation } from "@/hooks/useTranslation";

export default function LanguagesSection({
  languages,
}: {
  languages: LanguageResponse[];
}) {
  const t = useTranslation();
  if (languages.length === 0) {
    return null;
  }
  return (
    <div className="flex flex-col gap-y-2">
      <span className="text-lg">{t.PROFILE_VIEW.LABELS.LANGUAGES_SECTION}</span>
      <div className="flex flex-wrap w-full gap-x-3 gap-y-4">
        {languages.map((language) => (
          <BadgeWithFlag
            key={language.id}
            flagCode={language.flag_code}
            title={language.name}
          />
        ))}
      </div>
    </div>
  );
}
